jQuery(document).ready(function () {
  var firstGridTimeline = new TimelineMax();

  var lady1 = TweenMax.fromTo(".lady1", 1.5,
    { x: "-100%", y: "0%", rotation: 20 },
    { x: "0%", y: "0%", rotation: 0, ease: Expo.easeOut }
  );

  var lady2 = TweenMax.fromTo(".lady2", 1.5,
    { x: "100%", y: "0%", rotation: -20 },
    { x: "0%", y: "0%", rotation: 0, ease: Expo.easeOut }
  );

  firstGridTimeline.add(lady1).add(lady2, 0);

  var controller3 = new ScrollMagic.Controller();

  new ScrollMagic.Scene({
    triggerElement: "#first-row-ingredient",
    duration: 300
  })
    .setTween(firstGridTimeline)
    .addTo(controller3);
});

jQuery(document).ready(function () {
  var controller = new ScrollMagic.Controller();

  /** FIRST ROW **/
  new ScrollMagic.Scene({
    triggerElement: "#first-row-ingredient",
    triggerHook: 0.8,
    reverse: true
  })
    .on("enter", function () {
      // Reset styles
      TweenMax.set([".skin1", ".skin2", ".skin3"], { clearProps: "all" });

      // Animate
      var firstRowTimeline = new TimelineMax();
      firstRowTimeline
        .fromTo(".skin1", 1.5, { x: "-100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut })
        .fromTo(".skin2", 1.5, { y: "-100%", opacity: 0 }, { y: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.3")
        .fromTo(".skin3", 1.5, { x: "100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.3");
    })
    .addTo(controller);

  /** SECOND ROW **/
  new ScrollMagic.Scene({
    triggerElement: "#second-row-ingredient",
    triggerHook: 0.8,
    reverse: true
  })
    .on("enter", function () {
      // Reset styles
      TweenMax.set([".skin1-1", ".skin2-2", ".skin3-3"], { clearProps: "all" });

      // Animate
      var secondRowTimeline = new TimelineMax();
      secondRowTimeline
        .fromTo(".skin1-1", 1.5, { x: "-100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut })
        .fromTo(".skin2-2", 1.5, { y: "100%", opacity: 0 }, { y: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.3")
        .fromTo(".skin3-3", 1.5, { x: "100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.3");
    })
    .addTo(controller);
});



jQuery(document).ready(function () {
  var controller = new ScrollMagic.Controller();

  var oilTimeline = new TimelineMax();
  oilTimeline.fromTo(".oil1 img", 1.5,
    { rotation: -90, opacity: 0, scale: 0.5 },
    { rotation: 0, opacity: 1, scale: 1, ease: Expo.easeOut }
  );

  new ScrollMagic.Scene({
    triggerElement: ".oil-grid", // Container class
    triggerHook: 0.8,
    reverse: true // So it plays again when scrolling back up
  })
    .setTween(oilTimeline)
    .addTo(controller);
});

jQuery(document).ready(function () {
  var controller = new ScrollMagic.Controller();

  new ScrollMagic.Scene({
    triggerElement: ".amino-acids-grid", // 👈 triggers when this specific grid enters
    triggerHook: 0.8,
    reverse: true // animate again on scroll up
  })
    .on("enter", function () {
      // Reset styles for repeatable animation
      TweenMax.set([".amino-acids", ".amino-acids-2"], { clearProps: "all" });

      // Create animation timeline
      var aminoTimeline = new TimelineMax();
      aminoTimeline
        .fromTo(".amino-acids-1", 1.5, { x: "-100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut })
        .fromTo(".amino-acids-2", 1.5, { x: "100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.2");
    })
    .addTo(controller);
});
jQuery(document).ready(function () {
  var controller = new ScrollMagic.Controller();

  new ScrollMagic.Scene({
    triggerElement: ".red-palm-grid",
    triggerHook: 0.8,
    reverse: true
  })
    .on("enter", function () {
      // Reset previous styles
      TweenMax.set([".red-palm-1", ".red-palm-2", ".red-palm-3"], {
        clearProps: "all"
      });

      var redPalmTimeline = new TimelineMax();
      redPalmTimeline
        .fromTo(".red-palm-1", 1.5, { x: "-100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut })
        .fromTo(".red-palm-2", 1.5, { x: "100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.3")
        .fromTo(".red-palm-3", 1.5, { x: "-100%", opacity: 0 }, { x: "0%", opacity: 1, ease: Expo.easeOut }, "-=1.3");
    })
    .addTo(controller);
});




